import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "./css/styles.css";
/**
 * Renders a button with vendor specific styles removed
 *
 * Forwards the ref to the underlying button
 */

const BlankButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    ...props
  } = _ref;
  const finalClassName = `${styles.button} ${className}`; // eslint-disable-next-line react/button-has-type

  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    className: finalClassName
  }, props));
});
BlankButton.displayName = 'BlankButton';
process.env.NODE_ENV !== "production" ? BlankButton.propTypes = {
  /**
   * Class name to append
   */
  className: PropTypes.string,

  /**
   * button type. See [MDN's <button> page](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type) for more details
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit'])
} : void 0;
BlankButton.defaultProps = {
  className: ''
};
export default BlankButton;